/*
 * @Author:
 * @LastEditTime: 2022-05-11 15:01:13
 * @Description:
 */
import store from '@/models/store'

const errorHandle = async (err, status) => {
  const errInfo = err.response
  if (_.includes([401], status)) {
    if (currentEnv.loginType === 'OIDC') {
      const userInfo = store.getters['Auth/userInfo']
      const idToken = userInfo.id_token
      sessionStorage.clear()
      localStorage.setItem('latestPath', window.location.href)
      authorizer.signoutRedirect({ id_token_hint: idToken })
      return
    }
    document.location.href = `${
      currentEnv.VUE_APP_EASC_PAGE
    }/#/login?callbackUrl=${encodeURIComponent(window.location.href)}`
    return
  }
  if (status === 404) {
    app.$message.error('请求的资源不存在')
    return
  }
  const error = errInfo.data.error
  // 先校验规则看有没有报错提示
  if (!_.isNil(error.validationErrors) && !_.isEmpty(error.validationErrors)) {
    app.$message.error(error.validationErrors[0].message)
    return
  }
  // 在看details报错提示
  if (error.details) {
    app.$message.error(error.details)
    return
  }
  app.$message.error(error.message)
}

export default (err, res) => {
  if (err) {
    return errorHandle(err, err.response.status)
  }
  if (res.status === 200 && res.request.responseURL.includes('/Account/Login')) {
    // 登录失效
    localStorage.setItem('latestPath', window.location.href)
    return authorizer.signinRedirect()
  }
  if (res.status === 204) {
    return {
      code: 0,
      data: null,
      msg: 'success',
    }
  }
  return {
    code: 0,
    data: res.data,
    msg: 'success',
  }
}
